<template>
  <div>
    <v-container fluid grid-list-md  v-if="showGoodByeImage">
      <v-layout row wrap>
        <v-flex xs12>
          <div class="goodbye-title">You are now being redirected to our partner’s page.</div>
        </v-flex>
        <v-flex xs12>
          <v-img
            alt=''
            :src='images["GoodBye"]'
            height='600px'
            contain />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GoodBye from '@/assets/offers/GoodBye.png';

export default {
  name: 'SpareFoot',
  data() {
    return {
      images: {
        GoodBye,
      },
      showGoodByeImage: true,
      postalCode: null,
    };
  },
  props: {
  },
  async mounted() {
    await this.retrieveInspections();
    setTimeout(() => {
      this.showGoodByeImage = false;
      window.location.href = `https://www.sparefoot.com/search.html?stid=427&location=${this.postalCode}`;
    }, 2000);
  },
  methods: {
    async retrieveInspections() {
      const { currentUser } = this.$store.state.User;
      const InspectionsResponse = await this.$store.dispatch('Inspection/loadInspections', currentUser.legacyId);
      if (InspectionsResponse && InspectionsResponse.folders
        && InspectionsResponse.folders.length > 0) {
        this.postalCode = InspectionsResponse.folders[0].postalCode;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.goodbye-title {
  font-size: 24px;
}
</style>
